import React, { useState } from "react";
import {Dialog} from 'primereact/dialog';
import GenericUI from "../generic.ui";
import {Translator} from "../../translator";
import { AuthenticationAPI } from "../../../api/authentication";

//import "./styles/smartphone.css";
//import "./styles/tablet.css";
import "./styles/desktop.css";

export default class AccountPanel extends GenericUI
{
    constructor( props ) {
        super( props );
        this.state = {
            visible: props.visible,
            edit: props.edit,
            account: undefined
        };
    }

    componentDidMount()
    {
        window.AccountPanel = this;
    }

    logout(e)
    {
        if( window.ConfirmDialogBox )
        {
            window.ConfirmDialogBox.show( 'confirm_logout', 'logout_confirm_message', () => {
                if( window.localStorage) localStorage.clear();
                if( window.sessionStorage) sessionStorage.clear();
                window.open('index.html', '_self');
            } );
        }
    }

    modify(e) {
        this.setState({edit: true });
    }

    update( e ){

    }

    loadCurrentAccount()
    {
        AuthenticationAPI.getCurrentAccount()
            .then( ( response ) => {
                if( response && response.data && response.data.account )
                {
                    this.setState( { visible: true, account: response.data.account } );
                }
            } )
        .catch( ( error ) => {
            if( window.Messenger )
            {
                window.Messenger.showMessage( 'error', error );
            }
        });
    }

    render()
    {
        super.render();
/**
 *                                     <tr>
                                        <td className="td-left label">{Translator.get("AI Secret Key")}</td>
                                        <td className="td-right"><input type="text" defaultValue="" placeHolder={Translator.get("enter_your_ai_secret_key")} /></td>
                                    </tr>

 */
        if( this.state.visible )
        {

            return(
                <div className="mask">
                    <Dialog
                        modal
                        visible={this.state.visible}
                        onHide={() => this.setState( { visible: false } ) }
                        header={Translator.get("account_preferences")}
                        className="account-panel no-text-select"
						closeOnEscape={true}
                    >
                        <div className="account-form">
                            <table>
                                <tbody>
                                    <tr>
                                        <td className="td-left label">{Translator.get("firstname")}</td>
                                        { !this.state.edit  && <td className="td-right">{this.state.account.firstname}</td> }
                                        { this.state.edit && <td className="td-right"><input type="text" defaultValue={this.state.account.firstname} placeHolder={Translator.get("enter_your_firstname")} /></td> }
                                    </tr>
                                    <tr>
                                        <td className="td-left label">{Translator.get("lastname")}</td>
                                        { !this.state.edit  && <td className="td-right">{this.state.account.lastname}</td> }
                                        { this.state.edit && <td className="td-right"><input type="text" defaultValue={this.state.account.lastname} placeHolder={Translator.get("enter_your_lastname")} /></td> }
                                    </tr>
                                    <tr>
                                        <td colSpan="2"><hr /></td>
                                    </tr>
                                    <tr>
                                        <td className="td-left label">{Translator.get("email")}</td>
                                        { this.state.edit && <td className="td-right"><input type="text" defaultValue={this.state.account.email} placeHolder={Translator.get("enter_your_email")} /></td> }
                                        { !this.state.edit && <td className="td-right">{ this.state.account.email }</td> }
                                    </tr>
                                    <tr>
                                        <td className="td-left label">{Translator.get("current_licence")}</td>
                                        <td className="td-right"><a href="./AOZ software licence En and Fr  V3 April 2025.pdf" target="_blank">{Translator.get(this.state.account.licence)}</a></td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        <div>&nbsp;</div>
                        <div className="account-buttons">
                            <button className="logout" onClick={(e)=>{this.logout(e)}}>{Translator.get("logout")}</button>
                            {/*<a href="#">{Translator.get("delete_account")}</a>*/}

                            <button className="cancel" onClick={() => this.setState( { visible: false } )}>{Translator.get("cancel")}</button>
                            { !this.state.edit && <button className="modify btn-special" onClick={(e)=>{this.modify(e)}}>{Translator.get("modify")}</button> }
                            { this.state.edit && <button className="save btn-special" onClick={(e)=>{this.save(e)}}>{Translator.get("update")}</button> }

                        </div>
                    </Dialog>
                </div>
            );
        }
        else
        {
            return null;
        
        }
    }
}